// extracted by mini-css-extract-plugin
export default {"cards":"images_cards__N+OiZ","text":"images_text__Tjgue","cardsContain":"images_cardsContain__CE8gr"};